import React from 'react';
import { Badge, Box, IconButton, Stack } from '@mui/material';
import { LocaleSwitcher } from '../../../i18n/components/LocaleSwitcher';
import { BellIcon } from '../../../icons/animated';
import { SettingsMenu } from '../Functions';

interface INavBarMobileActionsProps {
  isJobPosting: boolean;
  isMobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
}

export const NavBarMobileActions = ({
  isJobPosting,
  isMobileMenuOpen,
  onToggleMobileMenu,
}: INavBarMobileActionsProps) => {
  const isCandidate = localStorage.getItem('role') === 'Candidate';

  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={0.5}
      sx={{
        display: { xs: 'flex', lg: 'none' },
        flexShrink: 0,
      }}
    >
      <LocaleSwitcher variant='navbar' />

      {!isJobPosting && (
        <>
          {/* Notifications Trigger */}
          <IconButton
            size='medium'
            aria-label='Notifications'
            sx={{
              minWidth: 40,
              minHeight: 40,
              color: 'var(--navbar-text, #ffffff)',
              borderRadius: 2,
              p: 1,
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.08)',
              },
            }}
          >
            <Badge
              variant='dot'
              color='error'
              overlap='circular'
              sx={{
                '& .MuiBadge-badge': {
                  bgcolor: '#ef4444',
                  boxShadow: '0 0 0 2px var(--navbar-bg, #093725)',
                },
              }}
            >
              <BellIcon size={20} color="#ffffff" />
            </Badge>
          </IconButton>

          {/* System Settings for non-candidates */}
          {!isCandidate && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 40,
                minHeight: 40,
                borderRadius: 2,
                p: 0.5,
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.08)',
                },
              }}
            >
              <SettingsMenu />
            </Box>
          )}

          {/* Mobile Menu Hamburger Button */}
          <IconButton
            onClick={onToggleMobileMenu}
            aria-label='Toggle mobile menu'
            aria-expanded={isMobileMenuOpen}
            sx={{
              minWidth: 44,
              minHeight: 44,
              color: 'var(--navbar-text, #ffffff)',
              borderRadius: 2.5,
              p: 1,
              ml: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.12)',
              },
            }}
          >
            <Box
              sx={{
                width: 22,
                height: 22,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Box
                component='span'
                sx={{
                  display: 'block',
                  height: 2,
                  width: 20,
                  bgcolor: 'var(--navbar-text, #ffffff)',
                  borderRadius: 1,
                  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: isMobileMenuOpen ? 'rotate(45deg) translate(3.5px, 3.5px)' : 'translateY(-3px)',
                }}
              />
              <Box
                component='span'
                sx={{
                  display: 'block',
                  height: 2,
                  width: 20,
                  bgcolor: 'var(--navbar-text, #ffffff)',
                  borderRadius: 1,
                  my: 0.5,
                  transition: 'opacity 0.2s ease',
                  opacity: isMobileMenuOpen ? 0 : 1,
                }}
              />
              <Box
                component='span'
                sx={{
                  display: 'block',
                  height: 2,
                  width: 20,
                  bgcolor: 'var(--navbar-text, #ffffff)',
                  borderRadius: 1,
                  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: isMobileMenuOpen ? 'rotate(-45deg) translate(3.5px, -3.5px)' : 'translateY(3px)',
                }}
              />
            </Box>
          </IconButton>
        </>
      )}
    </Stack>
  );
};
